import React from 'react'

import { getTitleText } from 'src/pages/Achievements/subcomponents/AchievementWidget/AchievementWidget'
import routes from 'src/lib/rails-routes/rails-routes'
import { Box } from '@chatterbug/aaron'
import ActionsList from 'src/ui/Action/ActionsList'
import Action from 'src/ui/Action/Action'
import { usePageParams } from 'src/utils/params'
import { t } from 'src/lib/i18n-react'

import { TYPES } from '../../AchievementWidget'

import AchievementWidgetFooterSkeleton from './AchievementWidgetFooterSkeleton'
import FooterRowItem from './subcomponents/FooterRowItem/FooterRowItem'

const getActionLink = (widgetType, l2Code) => {
  let link = null
  let label = null
  switch (widgetType) {
    case TYPES.LIVE_LESSON:
      link = routes.advanced_achievements_live_lessons(l2Code)
      label = t('SEE ALL LIVE LESSONS')
      break
    case TYPES.WRITING:
      link = routes.language_journal(l2Code)
      label = t('See recent entries')
      break
    case TYPES.MEDIA:
      link = routes.language_media_list(l2Code)
      label = t('See all media')
      break
    case TYPES.CONCEPT:
      link = routes.concepts(l2Code)
      label = t('See all concepts')
      break
    default:
      break
  }

  if (!link || !label) {
    return null
  }

  return (
    <Box marginLeft="-8px">
      <ActionsList>
        <Action href={link}>{label}</Action>
      </ActionsList>
    </Box>
  )
}

const AchievementWidgetFooter = ({
  statItems,
  showPlaceholder,
  widgetType,
}) => {
  const { l2Code } = usePageParams()
  if (showPlaceholder) {
    return null
  }
  return (
    <AchievementWidgetFooterSkeleton
      header={t('All time %{type} Achievements', {
        type: getTitleText(widgetType),
      })}
      rowItems={statItems.map((statItem, i) => {
        return <FooterRowItem {...statItem} key={i} />
      })}
      widgetType={widgetType}
      footerLink={getActionLink(widgetType, l2Code)}
    />
  )
}

export default AchievementWidgetFooter
